// 类目管理
export const columns = [
  {
    title: '公告标题',
    dataIndex: 'title',
    width: 180,
    ellipsis: true,
    scopedSlots: { customRender: 'noticeTitle' },
  },
  {
    title: '发布时间',
    dataIndex: 'updateTime',
    width: 120,
    ellipsis: true,
  },
]
// 上级类目
export const categoryColumns = [
  {
    title: '类目名称',
    dataIndex: 'name',
    width: 120,
    ellipsis: true,
  },
  {
    title: '代码',
    dataIndex: 'code',
    width: 120,
    ellipsis: true,
  },
  {
    title: '上级类目',
    dataIndex: 'parentName',
    width: 120,
    ellipsis: true,
  },
  {
    title: '上级类目代码',
    dataIndex: 'parentCode',
    width: 120,
    ellipsis: true,
  },
]
// 类目权限管理
export const rawMaterialcategoryColumns = [
  {
    title: '数据源',
    dataIndex: 'parentName',
    width: 120,

  },
  {
    title: '类型',
    dataIndex: 'category',
    width: 120,
    ellipsis: true,
  },
  {
    title: '优先级',
    dataIndex: 'level',
    width: 90,
    ellipsis: true,
  },
  {
    title: '类目名称',
    dataIndex: 'name',
    width: 120,

  },



]